import React from 'react';
import * as S from './RescheduleLeft.styles';

import BreadCrumb from '../../common/BreadCrumb/BreadCrumb';
import HeaderReschedule from './HeaderReschedule/HeaderReschedule';
import RescheduleInfoBlock from './RescheduleInfoBlock/RescheduleInfoBlock';
import DifferentRoom from './DifferentRoomBlock/DifferentRoom';
import PaymentBlock from './PaymentBlock/PaymentBlock';
import RefundSelect from '../../CancelFlow/CancelLeftBlock/CancellationBody/RefundSelect/RefundSelect';

const RescheduleLeftBlock = ({activeTab, dateInfo, roomInfo, hotelInfo, fcdt, updateParams, isCheckAvailabilityDisabled, checkAvailability, updateActiveTab, fareList, statusMsg, hasRefund, refundBreakup, modifyAllowed, updatedHotelDetails, paySessionId, confirmReschedule, selectedRefundMode, updateRefundMode}) => {
    return(
      <S.LeftBlockMainWrap>
        <BreadCrumb />
        <S.LeftBlockOuterWrap>
          <HeaderReschedule activeTab={activeTab} hotelInfo={hotelInfo} hasRefund={hasRefund} />
          {(activeTab === 'details' && <RescheduleInfoBlock
            dateInfo={dateInfo}
            roomInfo={roomInfo}
            fcdt={fcdt}
            updateParams={updateParams}
            checkAvailability={checkAvailability}
            isCheckAvailabilityDisabled={isCheckAvailabilityDisabled}
          />) || null}
          {(activeTab === 'cost' && <DifferentRoom
            updateActiveTab={updateActiveTab}
            fareList={fareList}
            statusMsg={statusMsg}
            hasRefund={hasRefund}
            modifyAllowed={modifyAllowed}
            updatedHotelDetails={updatedHotelDetails}
          />) || null}
          {(activeTab === 'refund' && <RefundSelect
            header=""
            selectedRefundMode={selectedRefundMode}
            updateRefundMode={updateRefundMode}
            refundBreakUp={refundBreakup}
            confirmCancellation={confirmReschedule}
            updateActiveTab={updateActiveTab}
            previousTab="cost"
          />) || null}
          {(activeTab === 'pay' && <PaymentBlock
            updateActiveTab={updateActiveTab}
            paySessionId={paySessionId}
          />) || null}
        </S.LeftBlockOuterWrap>
      </S.LeftBlockMainWrap>
    );
}

export default RescheduleLeftBlock;